export default function clientConfig() {
  const config = {
    codCliente: 2156, // 9156 - HMG || 2156 - PRD
    plano: 5, //
    tipo: 2, //
  }

  return config
}
